export default "__VITE_ASSET__pv0KYWvK__"